const termExclusionList = ['of', 'the', 'and', 'for', 'de'];

export const searchMatcher = ({ label, searchText }: { label: string; searchText?: string }, term?: string) => {
  const searchExpressions = [];

  if (term) {
    const words = term.toLowerCase().split(' ');
    const allowedWords = words.filter((word) => !termExclusionList.includes(word));

    // match whole term to title / label
    searchExpressions.push({
      target: label,
      exp: new RegExp(term, 'gi'),
      weight: words.length + 1,
    });

    // match individual words that are not on the exclusion list to title / label
    searchExpressions.push({
      target: label,
      exp: new RegExp(allowedWords.join('|'), 'gi'),
      weight: 1,
    });

    // match individual words that are not on the exclusion list to optional searchText
    searchExpressions.push({
      target: searchText,
      exp: new RegExp(allowedWords.join('|'), 'gi'),
      weight: 0.5,
    });
  }

  return searchExpressions.reduce(
    (sum, { target, exp, weight }) =>
      // sum + (matches count * rule weight)
      sum + ((target && (target.match(exp) || []).length * weight) || 0),
    0
  );
};
